import { motion } from "framer-motion";

const FooterHeading = () => {
  return (
    <motion.h2
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className="text-2xl font-bold text-white"
    >
      Sertaç GÜLTEKİN Portfolio
    </motion.h2>
  );
};

export default FooterHeading;
